<template>
  <div class="page-container logistics-page">
    <div class="header-bar">
      <span class="header-back" @click="$router.back()">←</span>
      物流信息
    </div>

    <!-- 多个物流信息展示 -->
    <div v-if="logisticsList.length > 0" class="logistics-list">
      <div
        v-for="(item, index) in logisticsList"
        :key="index"
        class="logistics-card"
        @click="toggleDrawer(index)"
      >
        <!-- 物流基本信息卡片 -->
        <div class="logistics-header">
          <div class="company-info">
            <i class="el-icon-truck"></i>
            <span class="company-name">{{ item.logistics_company }}</span>
          </div>
          <div class="logistics-no-row">
            <span class="label">物流单号：</span>
            <span class="no-value">{{ item.logistics_no }}</span>
            <button class="copy-btn" @click.stop="copyLogisticsNo(item.logistics_no)">复制</button>
          </div>

          <!-- 最新进度（默认显示） -->
          <div v-if="item.traces && item.traces.length > 0" class="latest-trace">
            <div class="trace-time">{{ item.traces[0].time || item.traces[0].ftime }}</div>
            <div class="trace-desc">{{ item.traces[0].context }}</div>
          </div>
          <div v-else class="no-trace">
            暂无物流轨迹
          </div>

          <!-- 展开/收起指示器 -->
          <div class="expand-indicator">
            <i :class="drawerIndex === index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            <span>{{ drawerIndex === index ? '收起详情' : '展开详情' }}</span>
          </div>
        </div>

        <!-- 抽屉展开部分：完整物流轨迹 -->
        <transition name="slide">
          <div v-if="drawerIndex === index" class="logistics-drawer">
            <div class="timeline-container">
              <h3 class="section-title">完整物流轨迹</h3>
              <div class="timeline">
                <div
                  v-for="(trace, tIndex) in item.traces"
                  :key="tIndex"
                  class="timeline-item"
                  :class="{ 'is-first': tIndex === 0 }"
                >
                  <div class="timeline-dot-wrapper">
                    <div class="timeline-dot"></div>
                    <div v-if="tIndex !== item.traces.length - 1" class="timeline-line"></div>
                  </div>

                  <div class="timeline-content">
                    <div class="timeline-time">{{ trace.time || trace.ftime }}</div>
                    <div class="timeline-desc">{{ trace.context }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- 无物流信息提示 -->
    <div v-else class="empty-logistics">
      <i class="el-icon-box"></i>
      <p>暂无物流信息</p>
      <p class="empty-tip">请稍后再查询或联系客服</p>
    </div>
  </div>
</template>

<script>
import { getLogistics } from '../api/order'

export default {
  name: 'LogisticsDetail',
  data() {
    return {
      loading: false,
      orderId: null,
      logisticsList: [],
      drawerIndex: -1  // -1表示所有抽屉都关闭
    }
  },
  created() {
    this.orderId = this.$route.params.id
    this.loadLogisticsData()
  },
  methods: {
    async loadLogisticsData() {
      if (!this.orderId) {
        this.$message.error('缺少订单ID参数')
        this.$router.back()
        return
      }

      this.loading = true
      const loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })

      try {
        const res = await getLogistics(this.orderId)

        if (res.status === 1 && res.data) {
          const data = res.data
          // 支持多个物流单号的数据格式
          if (data.logistics_list && Array.isArray(data.logistics_list)) {
            this.logisticsList = data.logistics_list
          } else if (data.logistics_company) {
            // 兼容旧格式（单个物流）
            this.logisticsList = [{
              logistics_company: data.logistics_company,
              logistics_no: data.logistics_no,
              traces: data.traces || []
            }]
          }

          // 默认展开第一个物流（如果有多个）
          if (this.logisticsList.length > 0) {
            // 默认关闭所有抽屉，只显示最新进度
            this.drawerIndex = -1
          }

          if (this.logisticsList.length === 0) {
            this.$message.info('暂无物流信息')
          }
        } else {
          this.$message.error(res.msg || '获取物流信息失败')
        }
      } catch (error) {
        console.error('加载物流信息失败:', error)
        this.$message.error(error.msg || error.message || '加载失败')
      } finally {
        this.loading = false
        if (loadingInstance) {
          loadingInstance.close()
        }
      }
    },

    toggleDrawer(index) {
      if (this.drawerIndex === index) {
        // 如果已经展开，则收起
        this.drawerIndex = -1
      } else {
        // 展开当前点击的物流
        this.drawerIndex = index
      }
    },

    copyLogisticsNo(logisticsNo) {
      const input = document.createElement('input')
      input.value = logisticsNo
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)

      this.$message.success('物流单号已复制到剪贴板')
    }
  }
}
</script>

<style scoped>
.logistics-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.logistics-list {
  padding: 12px 16px;
}

.logistics-card {
  background: #fff;
  margin-bottom: 16px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}

.logistics-card:active {
  transform: scale(0.98);
}

.logistics-header {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  padding: 20px;
  color: #fff;
  cursor: pointer;
}

.company-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
}

.company-info i {
  font-size: 24px;
}

.logistics-no-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-bottom: 16px;
}

.label {
  opacity: 0.85;
}

.no-value {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  letter-spacing: 0.5px;
  flex: 1;
}

.copy-btn {
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  backdrop-filter: blur(4px);
}

.copy-btn:active {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(0.95);
}

.latest-trace {
  background: rgba(255, 255, 255, 0.15);
  padding: 12px;
  border-radius: 10px;
  margin-bottom: 12px;
}

.trace-time {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 6px;
}

.trace-desc {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.no-trace {
  text-align: center;
  padding: 12px;
  font-size: 14px;
  opacity: 0.85;
}

.expand-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  opacity: 0.9;
  margin-top: 8px;
}

.expand-indicator i {
  font-size: 16px;
}

/* 抽屉展开部分 */
.logistics-drawer {
  background: #fff;
  padding: 0 16px 16px;
}

.timeline-container {
  margin-top: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-left: 4px;
}

.timeline {
  position: relative;
  padding-left: 8px;
}

.timeline-item {
  position: relative;
  display: flex;
  gap: 16px;
  padding-bottom: 28px;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-dot-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding-top: 4px;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #dcdfe6;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #dcdfe6;
  z-index: 2;
  transition: all 0.3s;
}

.timeline-item.is-first .timeline-dot {
  background: #409EFF;
  box-shadow: 0 0 0 2px #409EFF, 0 0 0 6px rgba(64, 158, 255, 0.15);
  width: 16px;
  height: 16px;
}

.timeline-line {
  width: 2px;
  flex: 1;
  background: linear-gradient(to bottom, #e4e7ed 0%, transparent 100%);
  margin-top: 6px;
  min-height: 20px;
}

.timeline-content {
  flex: 1;
  padding-top: 1px;
}

.timeline-time {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  padding-left: 2px;
}

.timeline-desc {
  font-size: 14px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}

.timeline-item.is-first .timeline-desc {
  color: #303133;
  font-weight: 500;
}

/* 抽屉过渡动画 */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* 空状态 */
.empty-logistics {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-logistics i {
  font-size: 64px;
  margin-bottom: 16px;
  color: #dcdfe6;
}

.empty-logistics p {
  font-size: 16px;
  margin-bottom: 8px;
}

.empty-tip {
  font-size: 14px;
  opacity: 0.7;
}
</style>